import 'babel-polyfill'
import 'whatwg-fetch'
import 'intersection-observer'
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './script/app-main/'
import './script/mixin-eventhub'
import './style/style.sass'

Vue.use(VueRouter)

new Vue({
    el: '#app',
    render: h => h(App)
})
